import type { DefaultUom } from "../../api/types";
import { t } from "../../i18n/t";

/**
 * Shared floor formatting — extracted with the StockItemFinder lift (G-46).
 *
 * S5: the SAME `money` as everywhere else, re-exported rather than restated.
 * This was the twin of `builderShared.eur`, character for character.
 */
export { money as eur } from "../../i18n/intl";

/**
 * The unit a quantity is counted in, in the kiosk's language (G-85).
 *
 * `quantity` picks the plural form through `Intl.PluralRules`, which is why
 * Russian and Ukrainian carry four forms where English carries two. Omitting
 * it asks for the unit IN GENERAL — the count zero selects `other` in English
 * and Spanish and `many` in Russian and Ukrainian, which is the bare plural
 * those languages use for exactly that ("stems", "стеблей").
 */
export function uomLabel(uom: DefaultUom, quantity?: number): string {
  const count = quantity ?? 0;
  switch (uom) {
    case "STEM":
      return t("uom.stem", { count });
    case "CM":
      return t("uom.cm");
    case "ROLL":
      return t("uom.roll", { count });
    default:
      return t("uom.unit", { count });
  }
}
